import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByEntityType',
})
export class FilterByEntityTypePipe implements PipeTransform {
    transform(value: any[], entityTypes: string[], search?: string): any[] {
        if (!value) {
            return value;
        }
        return value.filter(item => {
            if (item.mainPlanning && item.mainPlanning.entitytype_key) {
                const matchesEntityType =
                    !entityTypes?.length || entityTypes.includes(item.mainPlanning.entitytype_key);
                if (!search) {
                    return matchesEntityType;
                }
                const searchLower = search.toLowerCase().trim();
                const matchesSearch =
                    item.comment?.toLowerCase().includes(searchLower) ||
                    item.afas_project_id?.toLowerCase().includes(searchLower) ||
                    item.location?.toLowerCase().includes(searchLower) ||
                    item.projectmanager_user?.name?.toLowerCase().includes(searchLower) ||
                    item.project?.name?.toLowerCase().includes(searchLower);

                return matchesEntityType && matchesSearch;
            }
            return false;
        });
    }
}
